module.exports = __webpack_public_path__ + "img/ic_toolbar.587f14b7.svg";